<template>
   <div class="container-fluid">
      <div class="row">
         <div class="col-sm-12">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title">
                     <h4 class="card-title">Tag List</h4>
                  </div>
               </div>
               <div class="card-body">
                  <div class="table-responsive">
                     <div class="row justify-content-between">
                        <div class="col-10 col-sm-10 col-md-6">
                           <!-- <div id="role_list_datatable_info" class="dataTables_filter">
                              <form class="mr-3 position-relative">
                                 <div class="form-group mb-0">
                                    <input type="search" class="form-control" id="exampleInputSearch" placeholder="Search" aria-controls="role-list-table" v-model="search">
                                 </div>
                              </form>
                           </div> -->
                        </div>
                        <div class="d-flex flex-row-reverse align-items-center col-2 col-sm-2 col-md-6">
                           <b-button variant="outline-primary" class="mx-2 border-none d-flex align-items-center" v-on:click="redirectAdd"><i class="las la-plus-square h4 m-0 p-0"></i></b-button>
                        </div>
                     </div>

                     <data-tables-server :data="tags" :total="dataCount" @size-change="handleSizeChange" @current-page-change="handleCurrentChange">
                        <el-table-column :index="indexMethod" type="index" label="No." width="50" align="center"></el-table-column>                        
                        <el-table-column prop="name" label="Name" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.name}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="description" label="Description" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.description}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="order" label="Order" min-width="150" header-align="center" align="center">
                           <template scope="scope">
                              <span class="text-truncate">{{scope.row.orderby}}</span>
                           </template>
                        </el-table-column>
                        <el-table-column prop="action" label="Action" min-width="100" align="center">
                           <template scope="scope">
                              <a class="iq-bg-primary" v-b-tooltip.top title="Edit" href="javascript:void(0);" v-on:click="redirectEdit(scope.row.name)"><i class="ri-pencil-line mr-1"></i></a>
                              <a class="iq-bg-primary" v-b-tooltip.top title="Delete" href="javascript:void(0);" v-on:click="deleteRecord(scope.row.name)"><i class="ri-delete-bin-line mr-1"></i></a>
                           </template>
                        </el-table-column>
                     </data-tables-server>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { DataTablesServer } from 'vue-data-tables';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';

const config = require("../../../../../config");
locale.use(lang)

Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(DataTablesServer)

export default {
   name:'TagList',
   data() {
      return {
         tags: [],
         dataCount: 0,
         currentPage: 1,
         pageSize: 20,
         order: {
            column: null,
            order: null
         },
         search: '',
         delForm: {
            name:''
         },
      }
   },
   computed: {
      filteredTags: function() {
         const searchTerm = new RegExp(this.search, "i");
         return this.tags.filter((tag) => {
            return searchTerm.test(tag.name)
               || searchTerm.test(tag.description)
               || searchTerm.test(tag.orderby);
         });
      }
   },
   mounted: async function() {
      await this.getData();
   },
   methods: {
      getData: async function() {
         try {
            const res = await axios.get(config.api.URL + '/api/tags', {
               params: {
                  m: this.$route.meta.uid,
                  pageno: this.currentPage,
                  limit: this.pageSize,
                  ordercolumn: this.order.column,
                  order: this.order.order
               }
            });
            this.tags = res.data.rows;
            this.dataCount = res.data.count;
         } catch(error) {
            alert("Error: Unable to retrieve data");
            console.log("Error: ", error)
         }
      },
      redirectEdit: async function(tag) {
         this.$router.push({path: '/tags/edit/' + tag});
      },
      deleteRecord: async function(name) {
         try {
            if(confirm("Are you sure you want to delete this record?")) {
               this.delForm.name = name;
               await axios.post(config.api.URL + '/api/tags/delete', this.delForm, { params: { m: this.$route.meta.uid } });
               alert("Record deleted.");
               location.reload();
            }
         } catch(error) {
            alert("Error: Delete role unsuccessful.");
            console.log("Error:", error);
         }
      },
      redirectAdd: async function() {
         this.$router.push({path: '/tags/add'});
      },
      handleSizeChange: async function(val) {
         this.pageSize = val;
         await this.getData();
      },
      handleCurrentChange: async function(val) {
         this.currentPage = val;
         await this.getData();
      },
      indexMethod(index) {
         return (this.currentPage - 1) * this.pageSize + index + 1 
      }
   }
}
</script>